const PILLARS = [
  {
    tag: "Mission",
    tone: "green",
    title: "The independent opinion",
    body: "Keglam Services gives businesses an independent, expert opinion on the technology they depend on most — before a costly investment goes wrong. We run comprehensive reviews of security, SEO, and code quality with no incentive but the truth, then build the tools that let your business run itself.",
  },
  {
    tag: "Vision",
    tone: "amber",
    title: "Standard practice, not a luxury",
    body: "A future where “get a second opinion” is as normal in business technology as it is in medicine — where independent review comes standard, and secure, ready-to-use software is something any owner can pick off the shelf instead of building from scratch.",
  },
  {
    tag: "Goal",
    tone: "red",
    title: "Trust, earned by the hour",
    body: "Earn trust one hour at a time. We start with a single, unbiased review — no strings attached. From there, we aim to become your on-call programmer, then equip you with ready-made packages so your business runs faster, safer, and leaner.",
  },
] as const;

export function Pillars() {
  return (
    <section id="mission" className="k-band">
      <div className="k-shell k-sec">
        <p className="k-label">Why we exist</p>
        <h2>Mission, vision, goal</h2>

        <div className="k-pillars">
          {PILLARS.map((pillar) => (
            <article key={pillar.tag} className={`k-pillar k-pillar--${pillar.tone}`}>
              <span className={`k-chip k-chip--${pillar.tone}`}>{pillar.tag}</span>
              <h3>{pillar.title}</h3>
              <p>{pillar.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
